import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchPeople } from '../../../../actions/person/personList'
import People from '..'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterSelector, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { PersonListState } from '../../../../reducers/person/personList'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { Button, Fab, Stack, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import Person from '../../../../models/Person'
import { fetchGeneralDesc } from '../../../../actions/generalDesc'
import { fetchCountries } from '../../../../actions/country/countryList'
import { personTypeToDescription, visiblePersonTypes } from '../../../Client/Profile'
import { isAdmin, isClient, isHeadSales, isManager, SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { fetchProvinces } from '../../../../actions/deliveryLocation/provinceList'
import { getToken } from '../../../../utils/fetchApi'
import moment from 'moment'
import { FiletypeXls } from 'react-bootstrap-icons'

interface Props {
  fullInfo?: boolean
  personList: PersonListState
  session: SessionState
}

const PersonList: React.FC<Props> = ({ personList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('person')
  const { theme } = useThemeContext()
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchPeople(history.location.search))
    dispatch(fetchGeneralDesc('?type=cpt'))
    dispatch(fetchCountries())
    dispatch(fetchProvinces(`?all=true`))
  }, [dispatch, history.location.search, edit])


  const linkToPersonEdit = (person: Person) => {
    if (!isClient(session)) {
      const editUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/people/update/${person.id}`
      history.push(editUrl, { update: edit })
    }
  }


  const DownloadButton = () => {
    const handleDownloadAndShare = async () => {

      const url = `${process.env.REACT_APP_API_URL}/DLPeople?access_token=${getToken()}`

      try {

        // 1. Fetch modificado para evitar la descarga automática
        const response = await fetch(url);

        // 2. Obtener el blob y el nombre del archivo del header
        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        const fileNameMatch = contentDisposition?.match(/filename=(.+)/);

        const fileName = fileNameMatch ? fileNameMatch[1] : `personas-${moment().tz("America/Argentina/Buenos_Aires").format('YYYY-MM-DD')}-industrias_saladillo.xlsx`;

        // 3. Crear el File con el tipo MIME correcto
        const file = new File([blob], fileName, {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // Verificar específicamente si se puede compartir el archivo
        if (navigator.share && navigator.canShare?.({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: t('download', { ns: 'others' }),
            text: t('shareText', { ns: 'others' }) || 'Compartir usabilidad'
          });
          return
        } else {
          window.open(
            url,
            '_blank'
          );
        }
      } catch (error) {
        console.error('Error al descargar/compartir:', error);
        // 4. Fallback final (tu método original))
        window.open(
          url,
          '_blank'
        );
      }
    };
    return (
      <Stack display="flex" flexDirection='row' justifyContent="flex-start" padding="10px" paddingTop="20px">
        <Button
          id="download"
          aria-label="download"
          size='large'
          style={{ textTransform: 'none' }}
          onClick={() => handleDownloadAndShare()}
        >
          {t('download')}&nbsp;&nbsp;<FiletypeXls size={30} />
        </Button>
      </Stack>
    );
  }


  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value))

  const filterVisiblePersonTypes = visiblePersonTypes.filter( pt => isHeadSales(session) ? pt !== 'A' && pt !== 'M' : isManager(session) ? pt !== 'A' : true )

  return (
    <div>
      <FiltersBar>
        <FilterTextField name="fullName" label={t("firstName")} />
        <FilterTextField name="email" label={t("email")} />
        <FilterTextField name="documentNumber" label={t("documentNumber")} />
        {isAdmin(session) || isHeadSales(session) || isManager(session) ? <FilterSelector name="personType" menuItems={filterVisiblePersonTypes} textAdapter={translatePersonTypeDescription} label={t('personType')} /> : <></>}
        {isAdmin(session) || isHeadSales(session) || isManager(session) ? <FilterTextField name="byPersonTypeId" label={t("byPersonTypeId")} /> : <></>}
      </FiltersBar>
      <People
        rows={(personList.people || []).map(s => ({ data: s }))}
        loading={personList.isFetching}
        pagination={personList.pagination || undefined}
        onClickInfo={linkToPersonEdit}
        adminInfo={isAdmin(session)}
        managerInfo={isManager(session)}
        headsalesInfo={isHeadSales(session)}
      />
      {<DownloadButton />}

      <Tooltip title={t("create")}>
        <Fab color="primary" size="medium" variant="extended" sx={{ position: 'fixed', bottom: theme.spacing(4), right: theme.spacing(3) }}
          onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/people/create`, { title: t('create') })}>
          <Add />
        </Fab>
      </Tooltip>
    </div>
  )
}



const mapStateToProps = (state: AppState) => ({
  personList: state.personList,
  session: state.session
})

export default connect(mapStateToProps, null)(PersonList)